/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Secrets for the destination.
 * @export
 * @interface CreateDestinationRequestSecrets
 */
export interface CreateDestinationRequestSecrets {
    /**
     * The AWS access key ID for the `kinesis`, `s3`, and `sqs` destinations. Required for `sqs`.
     * @type {string}
     * @memberof CreateDestinationRequestSecrets
     */
    awsKeyId?: string;
    /**
     * The AWS secret access key for the `kinesis`, `s3`, and `sqs` destinations. Required for `sqs`.
     * @type {string}
     * @memberof CreateDestinationRequestSecrets
     */
    awsSecretKey?: string;
    /**
     * The optional AWS session token for the `kinesis`, `s3`, and `sqs` destinations.
     * @type {string}
     * @memberof CreateDestinationRequestSecrets
     */
    awsSessionToken?: string;
    /**
     * The password for the `clickhouse` and `rabbitmq` destinations. Required for `rabbitmq`.
     * @type {string}
     * @memberof CreateDestinationRequestSecrets
     */
    password?: string;
    /**
     * The PEM-encoded RSA private key for the `snowflake` destination.
     * @type {string}
     * @memberof CreateDestinationRequestSecrets
     */
    privateKey?: string;
    /**
     * The service-account credentials JSON for the `bigquery`, `gcs`, and `pubsub` destinations. Required for `pubsub`.
     * @type {string}
     * @memberof CreateDestinationRequestSecrets
     */
    credentials?: string;
    /**
     * The AWS access key ID for the `redshift` destination.
     * @type {string}
     * @memberof CreateDestinationRequestSecrets
     */
    accessKeyId?: string;
    /**
     * The AWS secret access key for the `redshift` destination.
     * @type {string}
     * @memberof CreateDestinationRequestSecrets
     */
    secretAccessKey?: string;
    /**
     * The account access key for the `azureblob` destination.
     * @type {string}
     * @memberof CreateDestinationRequestSecrets
     */
    accessKey?: string;
    /**
     * The username for the `rabbitmq` destination. Required for `rabbitmq`.
     * @type {string}
     * @memberof CreateDestinationRequestSecrets
     */
    username?: string;
    /**
     * The connection string for the `azureservicebus` destination. Required for `azureservicebus`.
     * @type {string}
     * @memberof CreateDestinationRequestSecrets
     */
    connectionString?: string;
}

/**
 * Check if a given object implements the CreateDestinationRequestSecrets interface.
 */
export function instanceOfCreateDestinationRequestSecrets(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateDestinationRequestSecretsFromJSON(json: any): CreateDestinationRequestSecrets {
    return CreateDestinationRequestSecretsFromJSONTyped(json, false);
}

export function CreateDestinationRequestSecretsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDestinationRequestSecrets {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'awsKeyId': !exists(json, 'awsKeyId') ? undefined : json['awsKeyId'],
        'awsSecretKey': !exists(json, 'awsSecretKey') ? undefined : json['awsSecretKey'],
        'awsSessionToken': !exists(json, 'awsSessionToken') ? undefined : json['awsSessionToken'],
        'password': !exists(json, 'password') ? undefined : json['password'],
        'privateKey': !exists(json, 'privateKey') ? undefined : json['privateKey'],
        'credentials': !exists(json, 'credentials') ? undefined : json['credentials'],
        'accessKeyId': !exists(json, 'accessKeyId') ? undefined : json['accessKeyId'],
        'secretAccessKey': !exists(json, 'secretAccessKey') ? undefined : json['secretAccessKey'],
        'accessKey': !exists(json, 'accessKey') ? undefined : json['accessKey'],
        'username': !exists(json, 'username') ? undefined : json['username'],
        'connectionString': !exists(json, 'connectionString') ? undefined : json['connectionString'],
    };
}

export function CreateDestinationRequestSecretsToJSON(value?: CreateDestinationRequestSecrets | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'awsKeyId': value.awsKeyId,
        'awsSecretKey': value.awsSecretKey,
        'awsSessionToken': value.awsSessionToken,
        'password': value.password,
        'privateKey': value.privateKey,
        'credentials': value.credentials,
        'accessKeyId': value.accessKeyId,
        'secretAccessKey': value.secretAccessKey,
        'accessKey': value.accessKey,
        'username': value.username,
        'connectionString': value.connectionString,
    };
}

